module.exports = __webpack_public_path__ + "static/schneider-78105c537ff1404645c25e2d228a1c31.png";